export default {
  SELECTED_PRODUCT_IN_STORE: 'products'
}